import { ICartItemProps } from "../../cartInterface";
import DomainContactType from "../DomainContactType/index.tsx";
import DomainNameServer from "../DomainNameServer";
import DomainTerm from "../DomainTerm";
import * as S from "../styles.ts";
import UsDomainContactType from "../UsDomainContactType/index.tsx";

const Extras = ({ item, reviewOrder }: Partial<ICartItemProps>) => {
  const isDomain = item.type.name === "Domain Name";
  const isDomainTransfer = isDomain && item.type.action === "transfer";
  const isDomainBackorder = isDomain && item.type.action === "backorder";
  const isDomainPurchase = isDomain && !isDomainTransfer && !isDomainBackorder;
  const isVoipUser = item.type.name === "User";

  if (!isDomainTransfer && !isDomainPurchase && !isVoipUser) {
    return;
  }

  return (
    <S.ExtrasContainer>
      {isDomainPurchase ? (
        <>
          <DomainTerm
            item={item}
            reviewOrder={reviewOrder}
          />
          {item.requires_extra_details && (
            <>
              {item.type.variation === "us" ? (
                <UsDomainContactType
                  item={item}
                  reviewOrder={reviewOrder}
                />
              ) : (
                <DomainContactType
                  item={item}
                  reviewOrder={reviewOrder}
                />
              )}
            </>
          )}
        </>
      ) : isDomainTransfer ? (
        <DomainNameServer
          item={item}
          reviewOrder={reviewOrder}
        />
      ) : null}
    </S.ExtrasContainer>
  );
};

export default Extras;
